import React from "react";
import './Introduction.css';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Typography, Button, Container, createTheme} from '@mui/material';
import {ThemeProvider} from "@mui/styles";

//Intro for OTblog.page
const button = {
    padding: '0.5em 2.3em 0.5em 2.3em',
    marginLeft: '12%'
}

const theme = createTheme();

theme.typography.h3 = {
    fontSize: '38px',
    fontFamily: 'Georgia',
    fontWeight: 'normal',
    color: 'black',
    margin: '1em',
    '@media (max-width:800px)': {
        fontSize: '23px',
    },
};

theme.typography.h4 = {
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '53px',
    fontFamily: 'Georgia',
    color: 'black',
    margin: '0 12% 1em 12%',
    '@media (max-width:800px)': {
        fontSize: '15px',
        lineHeight: '30px',
    },
};

function IntroCard() {
    const {t} = useTranslation();
    const token = localStorage.getItem('AUTHORIZATION_TOKEN_BLOG');
    return (
        <Container>
            <img className='greydash' src="greydash.png" alt="grey-dash"/>
            <ThemeProvider theme={theme}>
                <Typography variant="h3">
                    {t('AboutPage.Introduction.Title')}
                </Typography>
                <Typography variant="h4">
                    {t("AboutPage.Introduction.Subtitle")}
                </Typography>
            </ThemeProvider>
            {!token &&
                <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    style={button}
                    to="/registration">
                    {t('AboutPage.Introduction.Join')}
                </Button>
            }
            <img className='yellowdash' src="yellowdash.png" alt="yellow-dash"/>
        </Container>
    )
}

export default IntroCard
